import React, { useState } from "react";
import { Button } from "../components/Button";
import { Card, CardProps } from "../components/Card";
import { ScribbleLine } from "../components/ScribbleLine";
import { Flex } from "../layouts/Flex";
import { MaxWidth } from "../layouts/MaxWidth";
import { Spacing } from "../layouts/Spacing";
import styles from "./CardsGrid.module.css";

export type CardsGridProps = {
  title?: string;
  items: CardProps[];
  max?: number;
  paginate?: boolean;
  page?: number;
};

export const CardsGrid = ({
  title,
  items,
  max = 12,
  paginate,
  page = 1,
}: CardsGridProps) => {
  let paginated = false;
  let total = 0;
  let current = max;
  // handle the "show more" click
  const [currentPage, setPage] = useState<number>(page);
  const updatePage = (currentPage: number): void => {
    setPage(currentPage + 1);
  };
  if (!items) return null;
  if (paginate && max && items.length > max) {
    paginated = true;
    total = items.length;
    current = currentPage * max;
    if (current > items.length) current = items.length;
    items = items.slice(0, max * currentPage);
  } else if (!paginate && max && items.length > max) {
    items = items.slice(0, max);
  }
  return (
    <Spacing className={title ? styles.hasTitle : styles.hasNoTitle}>
      <MaxWidth size="lg">
        {title && (
          <>
            <ScribbleLine />
            <h2 className={styles.title}>{title}</h2>
          </>
        )}
        <Flex items={3}>
          {items.map((item) => (
            <Card key={item?.url || item?.title} {...item} />
          ))}
        </Flex>
        {paginated && (
          <div className={styles.pagination}>
            <div className={styles.counter}>
              <b>
                {current} van {total}
              </b>
              &nbsp;
              <span>verhalen</span>
            </div>
            <div className={styles.buttonWrapper}>
              <Button
                variation="secondary"
                onClick={() => updatePage(currentPage)}
                disabled={current >= total}
              >
                Toon meer verhalen
              </Button>
            </div>
          </div>
        )}
      </MaxWidth>
    </Spacing>
  );
};
